/**
 * Weather Code Utilities (Web)
 * Re-exports shared weather code logic and adds web-specific icon URL resolution.
 */

import {
  getWeatherIconName as sharedGetWeatherIconName,
  isPrecipitationWeatherCode,
  precipPopThreshold,
} from 'rainowls-shared'

export { isPrecipitationWeatherCode, precipPopThreshold }

/**
 * Translate the finalized weather code through the shared master icon reference
 */
export function getWeatherIconName(weatherCode: number, isDay = true): string {
  return sharedGetWeatherIconName(weatherCode, isDay)
}

// Icon imports for web from rainowls-ui package (Vite handles these)
const iconModules = import.meta.glob('rainowls-ui/src/assets/icons/weather/*.svg', { eager: true, query: '?url', import: 'default' }) as Record<string, string>

// Build icon map from glob imports
const iconMap: Record<string, string> = {}
for (const path in iconModules) {
  const name = path.split('/').pop()?.replace('.svg', '') || ''
  iconMap[name] = iconModules[path]
}

/**
 * Get weather icon URL for a given weather code
 */
export function getWeatherIconUrl(weatherCode: number, isDay = true): string {
  const iconName = getWeatherIconName(weatherCode, isDay)
  return iconMap[iconName] || iconMap['DayClear'] || ''
}

// RainOwls color palette
export const weatherColors = {
  pop: '#60a5fa',      // Probability of precipitation
  popHigh: '#38bdf8',  // High probability (>=60%)
  rain: '#22c55e',     // Rain
  snow: '#38bdf8',     // Snow
}
